if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        const container = this.querySelector('.product-media-modal__content');

        if (!mediaId || !container) return;

        const allMedia = this.querySelectorAll('[data-media-id]');
        const activeMedia = this.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        allMedia.forEach((element) => {
          element.classList.remove('active');
        });

        activeMedia.classList.add('active');

        /*
         * Scroll only the modal content.
         * Do not use scrollIntoView(), because it can scroll
         * the product page behind the modal on mobile.
         */
        requestAnimationFrame(() => {
          container.scrollTop = activeMedia.offsetTop;
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
